export default __webpack_public_path__ + "static/media/polo.7e124c5a.JPG";